import createPersistedState from "vuex-persistedstate"
import Vue from 'vue'
import Vuex from 'vuex'

import users from './modules/users'
import language from "./modules/language"

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    users,
    language
  },
  plugins: [createPersistedState()]
})
